import React from 'react';
import PropTypes from 'prop-types';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';

function PriorityChip({ priority }) {
  const colorMap = {
    Alta: 'error',
    Media: 'warning',
    Baja: 'default',
  };
  return <Chip size="small" label={priority} color={colorMap[priority] || 'default'} />;
}

export default function RecommendationsCard({ recommendations = [] }) {
  return (
    <Card>
      <CardHeader title="Recomendaciones" subheader="Insights accionables para impulsar tu tienda" />
      <CardContent>
        {recommendations.length === 0 && (
          <Box sx={{ textAlign: 'center', py: 3 }}>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 1 }}>
              Recopilando datos para generar recomendaciones personalizadas...
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Las recomendaciones estarán disponibles cuando tengamos suficiente histórico de ventas.
            </Typography>
          </Box>
        )}
        <Stack spacing={2}>
          {recommendations.map((rec) => (
            <Box key={rec.id} display="flex" alignItems="center" justifyContent="space-between">
              <Box display="flex" alignItems="center" gap={1}>
                {rec.icon && <i className={rec.icon} style={{ fontSize: 18 }} />}
                <div>
                  <Typography variant="body2" fontWeight={500}>{rec.title}</Typography>
                  <Tooltip title={rec.reason} arrow>
                    <PriorityChip priority={rec.priority} />
                  </Tooltip>
                </div>
              </Box>
              {rec.ctaLabel && (
                <Button size="small" variant="outlined" href={rec.ctaLink} sx={{ whiteSpace: 'nowrap' }}>
                  {rec.ctaLabel}
                </Button>
              )}
            </Box>
          ))}
        </Stack>
      </CardContent>
    </Card>
  );
}

RecommendationsCard.propTypes = {
  recommendations: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    title: PropTypes.string.isRequired,
    priority: PropTypes.string,
    reason: PropTypes.string,
    ctaLabel: PropTypes.string,
    ctaLink: PropTypes.string,
    icon: PropTypes.string,
  })),
};
